
import type { App, DirectiveBinding } from "vue";

export const vBtn = {
  install(Vue: App) {

    const bindingEvent = (el: any, binding: DirectiveBinding) => {
			// 确保只绑定一次事件
			if (el._isBindedTouch) return;

			// 处理点击拦截校验
			el._clickInterceptor = (e: Event) => {
				const handler = binding.value;
				if (typeof handler === 'function') {
					const canProceed = handler();
					if (canProceed === false) {
						// 阻止后续所有监听器执行（包括 Vue 模板绑定的 @click）
						e.stopImmediatePropagation();
						e.preventDefault();
					}
				}
			};

			// 创建事件处理函数并存储在元素上
			el._touchStartHandler = function () {
				// 获取当前元素的transform值
				const transform = window.getComputedStyle(el).transform;
				// 保存原始transform值以便恢复
				el._originalTransform = transform;
				// 应用缩放效果
				el.style.transform = transform === 'none' ? 'scale(0.97)' : transform + ' scale(0.97)';
			};

			el._touchEndHandler = function () {
				// 恢复到原始transform值
				if (el._originalTransform) {
					el.style.transform = el._originalTransform === 'none' ? '' : el._originalTransform;
				}
			};

			// 绑定事件
			el.addEventListener('touchstart', el._touchStartHandler);
			el.addEventListener('touchend', el._touchEndHandler);
			el.addEventListener('touchcancel', el._touchEndHandler);
			// 必须在捕获阶段拦截
			el.addEventListener('click', el._clickInterceptor, { capture: true });

			// 标记已绑定
			el._isBindedTouch = true;
		};

    const removeEvent = (el: any) => {
      // 如果没有绑定事件，则不执行
      if (!el._isBindedTouch) return;

      // 移除事件监听器
      if (el._touchStartHandler) {
        el.removeEventListener('touchstart', el._touchStartHandler);
      }

      if (el._touchEndHandler) {
        el.removeEventListener('touchend', el._touchEndHandler);
        el.removeEventListener('touchcancel', el._touchEndHandler);
      }

      if (el._clickInterceptor) {
				el.removeEventListener('click', el._clickInterceptor, { capture: true });
			}

      // 清除标记和引用
      el._isBindedTouch = false;
      el._touchStartHandler = null;
      el._touchEndHandler = null;
      el._clickInterceptor = null;
      el._originalTransform = null;
    };
    Vue.directive("btn", {
      mounted(el, binding: DirectiveBinding) {
        if (el.getAttribute('disabled') === null || el.getAttribute('disabled') === 'false') {
          bindingEvent(el, binding);
        }
      },
      unmounted(el) {
        removeEvent(el)
      },
      updated(el, binding: DirectiveBinding) {
        if (el.getAttribute('disabled') === null || el.getAttribute('disabled') === 'false') {
          if (!el._isBindedTouch) {
						bindingEvent(el, binding);
					} else {
						// 如果已经绑定，更新拦截器中使用的 binding（通过闭包引用 el._clickInterceptor 即可，
						// 但因为 binding 可能会变，这里 el._clickInterceptor 内部引用的是初始化的 binding。
						// 简单处理：如果 binding 值变了，重新绑定 click 逻辑）
						el._clickInterceptor_binding = binding;
					}
        } else {
          el._isBindedTouch && removeEvent(el)
        }
      }
    });
  },
};
